import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import QueuePage from "./pages/QueuePage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/fila/:org/:queueId/:canal?" element={<QueuePage />} />
        <Route path="*" element={<h1>Use /fila/:org/:queueId</h1>} />

      </Routes>
    </BrowserRouter>
  );
}
